module.exports = __webpack_public_path__ + "img/logo-expo.216371dc.png";